import { useCallback, useRef } from 'react';

interface IGroupSyncState {
  ids: Set<string>,
  columnsSignature: string,
}

export interface IUseGroupSyncStateValue {
  isGroupStale: (groupKey: string, currentIds: readonly string[], columnsSignature: string) => boolean,
  markGroupSynced: (groupKey: string, syncedIds: readonly string[], columnsSignature: string) => void,
}

const useGroupSyncState = (): IUseGroupSyncStateValue => {
  const syncedByGroupRef = useRef<Record<string, IGroupSyncState>>({});

  const isGroupStale = useCallback((
    groupKey: string,
    currentIds: readonly string[],
    columnsSignature: string,
  ): boolean => {
    const synced = syncedByGroupRef.current[groupKey];
    if (!synced) return true;
    if (synced.columnsSignature !== columnsSignature) return true;
    return currentIds.some((id) => !synced.ids.has(id));
  }, []);

  const markGroupSynced = useCallback((
    groupKey: string,
    syncedIds: readonly string[],
    columnsSignature: string,
  ): void => {
    syncedByGroupRef.current = {
      ...syncedByGroupRef.current,
      [groupKey]: { ids: new Set(syncedIds), columnsSignature },
    };
  }, []);

  return { isGroupStale, markGroupSynced };
};

export default useGroupSyncState;
